Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const featureWorkers_1 = require("../utils/featureWorkers");
const shared = require("@volar/shared");
function register(context) {
    return (uri, color, range) => {
        return (0, featureWorkers_1.languageFeatureWorker)(context, uri, range, (range, map, file) => {
            if (file.capabilities.documentSymbol) // TODO: add color capability setting
                return map.toGeneratedRanges(range);
            return [];
        }, (plugin, document, range) => { var _a; return (_a = plugin.getColorPresentations) === null || _a === void 0 ? void 0 : _a.call(plugin, document, color, range); }, (data, map) => map ? data.map(cp => {
            if (cp.textEdit) {
                const range = map.toSourceRange(cp.textEdit.range);
                if (!range)
                    return undefined;
                cp.textEdit.range = range;
            }
            if (cp.additionalTextEdits) {
                for (const textEdit of cp.additionalTextEdits) {
                    const range = map.toSourceRange(textEdit.range);
                    if (!range)
                        return undefined;
                    textEdit.range = range;
                }
            }
            return cp;
        }).filter(shared.notEmpty) : data);
    };
}
exports.register = register;
//# sourceMappingURL=colorPresentations.js.map